<template>
    <div class="advanced" @click="toggle" v-click-outside="close">
        <div class="title d-flex align-items-center pointer">
            <i class="ico-filter icon larger"></i>
            <strong>Advanced search</strong>
            <u :class="['ico-arrow-' + icon]"></u>
        </div>

        <div class="settings shadowed" v-if="isVisible">
            <div v-for="row in rows">
                <h5 class="bold">{{ row.title }}</h5>

                <div v-for="filter in row.filters">
                    <v-select
                        v-if="filter.type === 'select'"
                        :label="filter.label"
                        :placeholder="filter.placeholder"
                        :options="filter.items"
                        v-model="models[filter.table]"
                        @input="updateResults">
                    </v-select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'
    import extendedVSelect from '@/extends/vue-select'
    import vSlider from 'vue-slider-component';

    export default {
        props: {
            rows: Array,
            table: String,
        },
        data: function () {
            return {
                isVisible: false,
                icon: 'bottom',
                models: [],
            }
        },
        created: function() {
            // Create a copy of each assigned v-model so we can
            // bulk update multiple filters on update

            this.resetForm();
        },
        methods: {
            ...mapActions([
                'updateSearchFilters'
            ]),
            resetForm: function() {
                this.rows.forEach(row => {
                    row.filters.forEach(filter => {
                        this.models[filter.table] = null;
                    });
                });
            },
            toggle: function() {
                this.isVisible = true;
                this.icon = 'top';
            },
            close: function() {
                this.icon = 'bottom';
                this.isVisible = false;
            },
            updateResults: function() {
                // Updates the list of items according to the selected filters

                this.updateSearchFilters({ table: this.table, filters: this.models });
            }
        },
        components: {
            vSlider,
            vSelect: extendedVSelect
        }
    }
</script>

<style lang="scss">
    @import '../../assets/scss/_variables.scss';

    .advanced {
        position: relative;
        margin-left: 1rem;

        > .title {
            border: 1px solid $light;
            padding: 0.5rem 0.75rem;
            border-radius: 4px;
            font-size: $font-size-small;
            color: $darker;

            .icon {
                color: $color-1;
            }

            strong {
                margin: 0 0.75rem 0 0.25rem;
            }
        }

        > .settings {
            position: absolute;
            top: 100%;
            left: 0;
            width: 200%;
            background: $lightest;
            padding: 1.5rem;
            z-index: 1;

            h5 {
                color: $darker;
                border-bottom: 1px solid $light;
                padding-bottom: 0.5rem;
                margin: 1.5rem 0 0.5rem;

                &:first-child {
                    margin-top: 0;
                }
            }

            .v-select {
                margin-bottom: 1rem;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// AdvancedSearch.vue?2651af1a